// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__r5fcA","header":"styles_header__HOuuL","permissions":"styles_permissions__SNWOH","permission":"styles_permission__DDzsn"};